import React from 'react';
import PropTypes from 'prop-types';

import utils from './utils';
import Avatar from '../Components/Avatar';

const SimpleReply = ({ comment }) =>
    (<div className='comment comment-simple'>
        <div className='comment-one-liner'>
            <Avatar
                name={`${comment.owner.first_name} ${comment.owner.last_name}`}
                email={comment.owner.email}
                login={comment.owner.login}
                classes={'comment-avatar'}
            />
            <div className='comment-column'>
                <div className='posted-info'>
                    <span className='user' data-what='reply-author'>
                        { `${comment.owner.first_name} ${comment.owner.last_name}` }
                    </span>
                    <span className='pub-date' data-what='reply-date'>
                        { comment.published }
                    </span>
                </div>
                <div
                    className='content comment-text'
                    dangerouslySetInnerHTML={utils.createMarkup(comment.content)}
                    data-what='reply-body'
                />
            </div>
        </div>
    </div>);

export default SimpleReply;

SimpleReply.propTypes = {
    comment: PropTypes.object
};
